import React, { Fragment } from "react";

const TableSkeleton = ({ length = 3, colSpan = 4 }) => {
  const rows = Array.from({ length });
  const columns = Array.from({ length: colSpan });

  return (
    <Fragment>
      {rows.map((_, rowIndex) => (
        <tr key={rowIndex} className="w-full items-center border-b border-gray-100">
          {columns.map((__, colIndex) => (
            <td key={colIndex} className="px-4 py-3">
              <div
                className={`h-5 rounded-md animate-pulse ${
                  rowIndex === 0
                    ? "bg-gray-200"
                    : rowIndex === 1
                      ? "bg-gray-100"
                      : "bg-gray-50"
                }`}
                style={{
                  width: colIndex === 0 ? "70%" : colIndex === colSpan - 1 ? "50%" : "85%",
                }}
                aria-label="Loading content"
                role="status"
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </Fragment>
  );
};

export default TableSkeleton;
